import { TuiBadge } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { TuiIcon, TuiButton } from '@taiga-ui/core';
import { Subject } from 'rxjs';
import { RequestService } from '@core/services/request/request.service';
import { GroupActionsViews } from '@features/requests/request-list/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-group-actions-header',
  imports: [TuiButton, TuiBadge, TuiIcon, TranslatePipe],
  templateUrl: './group-actions-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupActionsHeaderComponent {
  $viewObserver = input.required<Subject<never>>({
    alias: 'viewObserver',
  });
  $viewChanged = output<GroupActionsViews>({
    alias: 'viewChangedOutput',
  });
  $title = input.required<string>({ alias: 'title' });

  $previousView = input.required<GroupActionsViews>({ alias: 'previousView' });

  $canGoBack = input.required<boolean>({ alias: 'canGoBack' });

  public readonly requestService = inject(RequestService);

  $selectedRequestsCount = this.requestService.selectedRequestsCount;
  protected readonly GroupActionsViewsTypes = GroupActionsViews;
}
